import { faGithub } from '@fortawesome/free-brands-svg-icons/faGithub';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF';
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons/faLinkedinIn';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons/faEnvelope';
import { faFileCode } from '@fortawesome/free-regular-svg-icons/faFileCode';

// See https://fontawesome.com/icons?d=gallery&s=brands,regular&m=free
// to add other icons.

const data = [
  {
    link: 'https://github.com/deen-abdullah',
    label: 'Github',
    icon: faGithub,
  },
  {
    link: 'https://www.linkedin.com/in/deen-abdullah/',
    label: 'LinkedIn',
    icon: faLinkedinIn,
  },
  {
    link: 'https://leetcode.com/u/rabimist/',
    label: 'LeetCode',
    icon: faFileCode,
  },
  {
    link: 'https://www.facebook.com/rabi.mist',
    label: 'Facebook',
    icon: faFacebookF,
  },
  {
    link: 'https://www.instagram.com/rabi.mist/',
    label: 'Instagram',
    icon: faInstagram,
  },
  {
    link: 'mailto:deen.m.abdullah@gmail.com',
    label: 'Email',
    icon: faEnvelope,
  },
];

export default data;
